/**
 * Front Page JS
 *
 * @since 0.1.0
 */

import {GraphOverall, GraphBreakdown} from './graph.js';

// console.log('Site:front-page');

if (document.body.classList.contains('page-front-page')) {
  // Non-interactive top-level graphs
  document.querySelectorAll('[data-graph-overall]').forEach((element) => {
    /* eslint-disable-next-line */
    new GraphOverall(element);
  });

  document.querySelectorAll('[data-graph-breakdown]').forEach((element) => {
    // This class handles the graph and hide/showing it via the button since that's tied to the animation
    /* eslint-disable-next-line */
    new GraphBreakdown(element);
  });

  // const g = new GraphBreakdown(document.getElementById('breakdown-english-language-arts').closest('[data-graph-breakdown]'));
  // g.animateFirstYear();

  // trigger 2020 notice fancybox to open on page load
  // document.getElementById('notice-2020-trigger').click();
}


document.querySelectorAll('.graph-container.overall').forEach((element) => {
  const options = {
    // rootMargin : '0px',
    threshold : 0.7,
  };

  const observer = new IntersectionObserver(callback, options);

  observer.observe(element);
});


function callback(entries, observer) {
  // console.log('Site:front-page:callback');
  // console.log('entries', entries);

  for (let i = entries.length - 1; i >= 0; i--) {
    if (entries[i].isIntersecting) {
      entries[i].target.classList.add('visible');
    }
  }
}
